import { makeStyles, tokens } from "@fluentui/react-components";
import { HeaderPadding } from "@ms/planner-generic-controls/lib/local/constants/StyleConstants";
import { flexParent } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
/**
 * Set by the My Tasks page on the list container while the view content is narrow. The list keys its
 * layout off it so the page, rather than the list, owns the scroll at those widths.
 */ export const NARROW_CONTENT_MARKER = "data-narrow-content";
const narrowContentAncestor = `[${NARROW_CONTENT_MARKER}="true"] &`;
const root = {
    ...flexParent("column"),
    flex: "1 1 auto",
    minHeight: 0,
    overflow: "visible",
    gap: tokens.spacingVerticalM,
    paddingTop: tokens.spacingVerticalM,
    paddingBottom: tokens.spacingVerticalM,
    paddingLeft: HeaderPadding,
    paddingRight: "70px",
    maxWidth: "980px",
    // Narrow views scroll the whole page rather than just the list, so size to the content.
    [narrowContentAncestor]: {
        flex: "0 0 auto"
    }
};
const accordionScrollRegion = {
    minHeight: 0,
    overflowY: "auto",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
        display: "none",
        width: 0,
        height: 0
    },
    // Hand scrolling to the page root at narrow widths; a nested scroll region here would trap the
    // gesture and keep the header pinned.
    [narrowContentAncestor]: {
        overflowY: "visible"
    }
};
// align with task cards (32px icon container with 20px icon sizing, (32 - 20 = 12 => 12 / 2 = 6px plus 12px from list padding = 18px))
const addTaskRowLeftPadding = "18px";
const addTaskRow = {
    ...flexParent("row"),
    alignItems: "center",
    gap: tokens.spacingHorizontalS,
    height: "60px",
    minHeight: "60px",
    width: "100%",
    boxSizing: "border-box",
    flexShrink: 0,
    paddingRight: tokens.spacingHorizontalM,
    paddingLeft: addTaskRowLeftPadding,
    cursor: "pointer",
    borderRadius: tokens.borderRadius3XLarge,
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke4}`,
    backgroundColor: tokens.colorNeutralBackground1,
    justifyContent: "flex-start",
    ":hover": {
        backgroundColor: tokens.colorNeutralBackground1Hover
    }
};
const addTaskIcon = {
    color: tokens.colorCompoundBrandBackground,
    fontSize: tokens.fontSizeBase500
};
const addTaskText = {
    color: tokens.colorNeutralForeground4,
    fontSize: tokens.fontSizeBase300
};
const addTaskInput = {
    flexGrow: 1
};
// Hidden off-screen announcer: stays in a11y tree, spoken as focus announcement when focused.
const completionAnnouncer = {
    position: "absolute",
    left: "-10000px",
    top: "auto",
    width: "1px",
    height: "1px",
    overflow: "hidden",
    outlineStyle: "none"
};
/**
 * Styles hook for MyTasksListView
 */ export const useMyTasksListViewStyles = makeStyles({
    root,
    accordionScrollRegion,
    addTaskRow,
    addTaskIcon,
    addTaskText,
    addTaskInput,
    completionAnnouncer
});
